import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { isNil } from '@grandvisionhq/utils';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import { REMOVE_CART_VOUCHER_CODES } from '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import { GET_CART } from '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import { RemoveVoucherCode } from './RemoveVoucherCode.js';

var RemoveVoucherCodeContainer = (_param)=>{
    var { voucherCode  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "voucherCode"
    ]);
    const [{ cartId  }] = useCartStorage();
    const [removeCartVoucherCodes] = useMutation(REMOVE_CART_VOUCHER_CODES);
    const handleRemove = React.useCallback(()=>{
        if (!cartId || !voucherCode) {
            return;
        }
        removeCartVoucherCodes({
            variables: {
                cartInput: {
                    cartId,
                    voucherCodes: [
                        voucherCode
                    ]
                }
            },
            update (cache, { data  }) {
                if (data && data.removeCartVoucherCodes.success === true) {
                    const newCart = data.removeCartVoucherCodes.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: {
                            id: cartId
                        },
                        data: {
                            cart: {
                                cart: newCart,
                                validationErrors: null,
                                failures: null
                            }
                        }
                    });
                }
            }
        });
    }, [
        cartId,
        removeCartVoucherCodes,
        voucherCode
    ]);
    if (isNil(cartId) || !voucherCode) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(RemoveVoucherCode, swcHelpers.extends({
        onRemove: handleRemove,
        voucherCode: voucherCode
    }, rest));
};

export { RemoveVoucherCodeContainer };
//# sourceMappingURL=RemoveVoucherCodeContainer.js.map
